export function useObjectivesLiveApi(): boolean {
  if (import.meta.env.VITEST) {
    return false;
  }
  return import.meta.env.VITE_OBJECTIVES_USE_LIVE_API !== 'false';
}
